import {Message} from "element-ui";

export async function processErrors(errors) {
    const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
    if (typeof errors.data === 'string') {
        Message({
            message: `Error: ${errors.msg}`,
            type: 'error',
        });
    } else if (errors.data.length != 0) {
        for (const field in errors.data) {
            if (errors.data.hasOwnProperty(field)) {
                for (let index = 0; index < errors.data[field].length; index++) {
                    const message = errors.data[field][index];
                    Message({
                        message: `Error: ${message}`,
                        type: 'error',
                    });
                    await sleep(1000); // 等待 2 秒
                }
            }
        }
    }else{
        Message({
            message: `Error: ${errors.msg}`,
            type: 'error',
        });
    }
}